import { Select, FormControl, MenuItem, FormHelperText, InputLabel } from '@material-ui/core';
import React from 'react';

const SelectCustom = (props) => {

    const { value, onChange, className, label, error, options = [], required } = props;

    return <FormControl fullWidth={true} error={!!error} style={{ marginTop: '10px', marginBottom: '10px' }} required={required}>
        <InputLabel>{label}</InputLabel>
        <Select
            value={value}
            onChange={onChange}
            displayEmpty
            className={className}
        >
            {options.map(el => <MenuItem key={el.value} value={el.value}>{el.label}</MenuItem>)}
        </Select>
        <FormHelperText>{error}</FormHelperText>
    </FormControl>
}

export default SelectCustom